import React, { createContext, useState, useEffect } from "react";

const DeviceContext = createContext();

const DeviceProvider = ({ children }) => {
    const [deviceType, setDeviceType] = useState(""); // "mobile", "desktop"
    const [orientation, setOrientation] = useState(""); // "portrait", "landscape"

    useEffect(() => {
        function checkDeviceType() {
            const userAgent = navigator.userAgent.toLowerCase();
            if (/iphone|ipad|ipod|android/.test(userAgent)) {
                setDeviceType("mobile");
            } else {
                setDeviceType("desktop");
            }
        }

        function checkOrientation() {
            if (window.matchMedia("(orientation: landscape)").matches) {
                setOrientation("landscape");
            } else {
                setOrientation("portrait");
            }
        }

        checkDeviceType();
        checkOrientation();

        window.addEventListener("resize", checkOrientation);

        return () => {
            window.removeEventListener("resize", checkOrientation);
        };
    }, []);

    const contextValue = {
        deviceType,
        orientation,
    };

    return (
        <DeviceContext.Provider value={contextValue}>
            {children}
        </DeviceContext.Provider>
    );
};

export { DeviceContext, DeviceProvider };